require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-how-to-set-up-a-facebook-traffic-ad.json") })
        }
      }, "path---tapd-in-how-to-set-up-a-facebook-traffic-ad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-how-to-set-up-a-facebook-traffic-ad!./.cache/json/tapd-in-how-to-set-up-a-facebook-traffic-ad.json
// module id = 850
// module chunks = 231608221292675